import React from 'react';

export default function VerticalLine() {
  return (
    <div className="bg-snow--d" style={{ width: '1px', height: '100%' }} />
  );
}



// WEBPACK FOOTER //
// ./src/components/modules/VerticalLine/index.js